import { render, staticRenderFns } from "./FormSelectMultipleQuestion.vue?vue&type=template&id=08ba3dc5"
import script from "./FormSelectMultipleQuestion.vue?vue&type=script&lang=js"
export * from "./FormSelectMultipleQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports